module.exports = __webpack_public_path__ + "static/img/circle_01.086b38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle_01.png
// module id = elBl
// module chunks = 1